import { Form, Nav, NavDropdown, Navbar } from 'react-bootstrap';
import React, { Component } from 'react';

import ChangeRoleSelect from './ChangeRoleSelect';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { logoutUser } from '../../redux/actions/user';
import { cognito_authority } from '../../pages/LoginPage/utils';

class NavbarTop extends Component<any, any> {
  helpDropdown = () => {
    return (
      <NavDropdown title={<i className='fa fa-question-circle' />} id='basic-nav-dropdown' className='mr-2'>
        <NavDropdown.Item href='/trainingMaterials'>{<i className='fa fa-book' />} Training Materials</NavDropdown.Item>
        <NavDropdown.Divider />
        <NavDropdown.Item href='/installApp'>{<i className='fa fa-download' />} Install Mobile App</NavDropdown.Item>
      </NavDropdown>
    );
  };

  adminDropdown = () => {
    if (this.props.isAdmin) {
      return (
        <NavDropdown title='Admin' id='basic-nav-dropdown' className='mr-2'>
          <li className='nav-item'>
            <Link className='dropdown-item' to='/Admin/viewUsers'>
              View Users
            </Link>
          </li>
          <li className='nav-item'>
            <Link className='dropdown-item' to='/Admin/addUser'>
              Add Users
            </Link>
          </li>
          <li className='nav-item'>
            <Link className='dropdown-item' to='/Admin/ActiveUsers'>
              Active Users
            </Link>
          </li>
          <li className='nav-item'>
            <Link className='dropdown-item' to='/Admin/deletedItems'>
              Deleted Items
            </Link>
          </li>
          <li className='nav-item'>
            <Link className='dropdown-item' to='/ImportVerification'>
              Import
            </Link>
          </li>

          {/* <NavDropdown.Item href="#settings">System Settings</NavDropdown.Item> */}
          <li className='nav-item'>
            <Link className='dropdown-item' to='/Admin/settings'>
              System Settings
            </Link>
          </li>
          <li className='nav-item'>
            <Link className='dropdown-item' to='/Admin/unassignedAssets'>
              Unassigned Assets
            </Link>
          </li>
          <li className='nav-item'>
            <Link className='dropdown-item' to='/Admin/owners'>
              Edit Owners
            </Link>
          </li>
        </NavDropdown>
      );
    }
    return null;
  };

  reportDropdown = () => {
    if (this.props.isAdmin) {
      return (
        <NavDropdown title='Reports' id='basic-nav-dropdown' className='mr-2'>
          <li className='nav-item'>
            <Link className='dropdown-item' to='/Admin/deviceRefreshReport'>
              Device Refresh Report
            </Link>
          </li>
          <li className='nav-item'>
            <Link className='dropdown-item' to='/Admin/deviceArchiveReport'>
              Report of all Devices
            </Link>
          </li>
          <li className='nav-item'>
            <Link className='dropdown-item' to='/Admin/perFYDeviceReport'>
              Per FY Device Refresh Report
            </Link>
          </li>
        </NavDropdown>
      );
    }
  };

  devDropdown = () => {
    if (this.props.isDevTeam) {
      return (
        <NavDropdown title='Dev' id='basic-nav-dropdown' className='mr-2'>
          <li className='nav-item'>
            <Link className='dropdown-item' to='/dev/runAsUser'>
              Run as User
            </Link>
          </li>
          <NavDropdown.Item href='#mobile'>Mobile</NavDropdown.Item>
          <NavDropdown.Item href='#runTests'>Run Tests</NavDropdown.Item>
        </NavDropdown>
      );
    }
    return null;
  };

  receivingDropdown = () => {
    if (!this.props.isGuest) {
      return (
        <NavDropdown title='Asset Management' id='basic-nav-dropdown' className='mr-2'>
          {this.props.departmentId === 19 && (
            <>
              <NavDropdown.Item href='/receiving'>All Requests</NavDropdown.Item>
              <NavDropdown.Item href='/requests'>Requested</NavDropdown.Item>
              <NavDropdown.Item href='/requests/ordered'>Ordered</NavDropdown.Item>
              <NavDropdown.Item href='/requests/barcoded'>Barcoded</NavDropdown.Item>
              <NavDropdown.Item href='/requests/eOneReady'>Enterprise One Items</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href='/purchaseOrders'>Purchase Orders</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href='/oitStock'>OIT Stock</NavDropdown.Item>
            </>
          )}
          <NavDropdown.Item href='/transfers'>Transferred Items</NavDropdown.Item>
          <NavDropdown.Item href='/salvage'>Salvage Items</NavDropdown.Item>
        </NavDropdown>
      );
    }
  };

  handleLogout = async () => {
    this.props.logoutUser();
    let so = window.open(`${cognito_authority}/logout`);
    so.close();
  };

  render() {
    return (
      <Navbar sticky='top' collapseOnSelect bg='dark' variant='dark' expand='lg'>
        {/* adjust expand prop value to change expansion of navbar contents */}
        <span className='form-inline'>
          <Navbar.Brand href='/' className='ml-0'>
            Asset Inventory
          </Navbar.Brand>

          {!this.props.isGuest && <ChangeRoleSelect />}
        </span>

        <Navbar.Toggle aria-controls='responsive-navbar-nav' />
        <Navbar.Collapse id='responsive-navbar-nav'>
          <Nav className='ml-auto'>
            {this.helpDropdown()}
            {/* {this.dashboardDropdown()} */}
            <Link className='nav-link' to='/'>
              Dashboard
            </Link>
            <Link className='nav-link' to='/map'>
              Map
            </Link>
            <Link className='nav-link' to='/inventory'>
              Inventory
            </Link>
            {/* <Link className='nav-link' to='/receiving'>
            Receiving
          </Link> */}
            {this.receivingDropdown()}
            {this.reportDropdown()}
            {this.adminDropdown()}
            {this.devDropdown()}
            <Nav.Link href={'/login'} onSelect={() => this.props.logoutUser()}>
              Logout
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

const mapStateToProps = (state: any) => {
  let purchaseOrders = false;
  try {
    state.user.roles.map((item) => {
      if (item.roleName === 'PO Admin' || item.roleName === 'PO Support' || item.roleName === 'Purchase Orders') purchaseOrders = true;
    });
  } catch (err) {}
  return {
    isAdmin: state.user.currentRole.isAdmin,
    isDevTeam: state.user.isDevTeam,
    isGuest: state.user.currentRole.roleName === 'Guest',
    departmentId: state.user.currentRole.departmentId,
    purchaseOrders: purchaseOrders,
  };
};

export default connect(mapStateToProps, { logoutUser })(NavbarTop);
